import React from "react";
import styled from "styled-components";
import { theme } from "../../Customization/Theme";

interface Props {
  error?: any;
  visible?: any;
  children?: React.ReactNode;
  [otherProps: string]: any;
}

const AppErrorMessage: React.FC<Props> = ({
  error,
  visible,
  ...otherProps
}) => {
  if (!visible || !error) return null;

  // Handle different types of errors safely
  let errorMessage = '';
  if (typeof error === 'string') {
    errorMessage = error;
  } else if (typeof error === 'object' && error !== null) {
    // If it's an object, try to extract a string representation
    if (error.message) {
      errorMessage = error.message;
    } else if (error.value) {
      errorMessage = String(error.value);
    } else if (error.toString && typeof error.toString === 'function') {
      errorMessage = error.toString();
    } else {
      errorMessage = JSON.stringify(error);
    }
  } else {
    errorMessage = String(error);
  }

  return (
    <StyledText {...otherProps} className="form-error">
      {errorMessage}
    </StyledText>
  );
};

export default AppErrorMessage;

const StyledText = styled.p`
  color: #f34e4e;
  font-size: 13px;
  font-family: ${theme.typography.fontFamily};
`;
